// extracted by mini-css-extract-plugin
export const footer = "FooterSection-module--footer--2Vy4m";
export const center = "FooterSection-module--center--1xyVB";
export const FooterSocialIcons = "FooterSection-module--FooterSocialIcons--3cDhu";
export const FooterCopyright = "FooterSection-module--FooterCopyright--AZQN0";
export const buyEth = "FooterSection-module--buyEth--2ymSD";
export const JoinMemberLink = "FooterSection-module--JoinMemberLink--3DVAN";